
import {Component, Prop, VModel, Vue} from "vue-property-decorator";

@Component({})
export default class Popup extends Vue {
  @VModel({})
  public showPopup!: boolean;

  @Prop({})
  public popup!: { color: string, code: number, message: string, timeout?: number };


  private listOfPopupTypes = [
    'success',
    'error',
    'warning',
    'info'
  ];

  mounted() {
    this.validPopupPropCheck()


  }

  validPopupPropCheck() {
    //check if given color is valid (in array listofpopuptypes)
  }
}
